import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "turnPond";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    turnPondList: {
      list: [],
      total: 0,
    },
  },
  actions: {
    //获取塘口下的渔种
    async getPondFishList(a, payload) {
      let result = await api.get(`/api/Fish/GetPurchaseFish/${payload}`);
      return result.data;
    },
    //周期批次
    async getPondUnclearedBatchNo(a, pondId) {
      let result = await api.get(
        `/api/FishBatch/GetPondUnclearedBatchNo/${pondId}`
      );
      return result.data;
    },
    //查询-----获取转塘所有数据
    async getTurnPondData({ commit }, payload) {
      let result = await api.get(
        `/api/TransferPond?${queryString.stringify(payload)}`
      );
      let fiterList = result.data.list.map((item) => {
        if (item.specType == 14000) {
          item.specType = "斤/尾";
        } else if (item.specType == 14001) {
          item.specType = "尾/斤";
        } else if (item.specType == 14002) {
          item.specType = "万尾";
          item.quantity = item.quantity / 10000;
        }
        return item;
      });
      if (result.status === 200) {
        commit("setTurnPondList", result.data);
      }
      return result;
    },
    //添加
    async addTurnPond(a, payload) {
      let result = await api.post("/api/TransferPond", payload);
      return result.data;
    },
    //删除数据
    async delTurnPondList(a, payload) {
      let result = await api.delete(`/api/TransferPond/` + payload);
      return result;
    },
    //删除数据
    async delTurnPondDetail(a, payload) {
      let result = await api.delete(`/api/TransferPond/Detail/` + payload);
      return result;
    },
    //编辑---获取单行数据
    async getEditTurnPondData(a, payload) {
      let result = await api.get(`/api/TransferPond/GetEditView/` + payload);
      let fiterList = result.data.details.map((item) => {
        if (item.specType == 14002) {
          item.quantity = item.quantity / 10000;
        }
        return item;
      });
      return result.data;
    },
    //修改
    async updateTurnPond(a, payload) {
      let result = await api.put(
        `/api/TransferPond/${payload.id}`,
        payload.data
      );
      return result.data;
    },
  },
  mutations: {
    // //转入基地
    // setBaseList(state, payload) {
    //     state.baseList = payload;
    // },
    // //转出基地
    // setBaseListOut(state, payload) {
    //     state.baseListOut = payload;
    // },
    setFishPondList(state, payload) {
      state.fishPondList = payload;
    },
    setFishPondListIn(state, payload) {
      state.fishPondListIn = payload;
    },
    setTurnPondList(state, payload) {
      state.turnPondList = payload;
    },
  },
  getters: {},
});

export default moduleName;
